export default function resizeWindow() {
    
    let fullWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (fullWidth !== window.innerWidth) {
        window.location.reload();
      }
    }, false)
}